import MainLayoutWithData from './MainLayoutWithData';

export default MainLayoutWithData;
